import React from 'react';
import { TextField, Select, MenuItem, InputLabel, FormControl, Box } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';

const RESOURCE_OPTIONS = [
  'boards',
  'boardTypes',
  'failure-causes',
  'groups',
  'printings',
  'system-users',
  'systems',
  'users',
];

export interface AuditFilters {
  user?: string;
  resource?: string;
  serial?: string;
  dateFrom?: string;
  dateTo?: string;
}

interface AuditFilterProps {
  filters: AuditFilters;
  onFilterChange: (filters: AuditFilters) => void;
}

const AuditFilter: React.FC<AuditFilterProps> = ({ filters, onFilterChange }) => {
  const handleText =
    (field: keyof AuditFilters) => (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilterChange({ ...filters, [field]: event.target.value });
    };

  const handleSelect = (event: SelectChangeEvent) => {
    onFilterChange({ ...filters, resource: event.target.value });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', p: 1, flexWrap: 'wrap' }}>
      <TextField
        label="User"
        size="small"
        variant="outlined"
        value={filters.user || ''}
        onChange={handleText('user')}
        sx={{ minWidth: 120 }}
      />
      <FormControl size="small" variant="outlined" sx={{ minWidth: 130 }}>
        <InputLabel>Resource</InputLabel>
        <Select value={filters.resource || ''} onChange={handleSelect} label="Resource">
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          {RESOURCE_OPTIONS.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Record ID"
        size="small"
        variant="outlined"
        value={filters.serial || ''}
        onChange={handleText('serial')}
        sx={{ minWidth: 120 }}
      />
      <TextField
        label="From"
        type="date"
        size="small"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        value={filters.dateFrom || ''}
        onChange={handleText('dateFrom')}
        sx={{ maxWidth: 160 }}
      />
      <TextField
        label="To"
        type="date"
        size="small"
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        value={filters.dateTo || ''}
        onChange={handleText('dateTo')}
        sx={{ maxWidth: 160 }}
      />
    </Box>
  );
};

export default AuditFilter;
